import React, { useState } from "react";

import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Popover from "@mui/material/Popover";

interface Props {
	children: React.ReactNode;
}

const HelperPopoverButton = ({ children }: Props) => {
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

	const open = Boolean(anchorEl);

	return (
		<>
			<IconButton
				size='small'
				onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
					setAnchorEl(event.currentTarget);
				}}>
				<InfoOutlinedIcon fontSize='inherit' />
			</IconButton>
			<Popover
				open={open}
				onClose={() => setAnchorEl(null)}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "left",
				}}>
				{children}
			</Popover>
		</>
	);
};

export default HelperPopoverButton;
